import loadable from "@loadable/component";

const ReviewsSectionV2 = loadable(() => import("./ReviewsSectionV2"));

export default (props: any): JSX.Element => <ReviewsSectionV2 {...props} />;
